import {remCalc} from '_themeUtils'

const productContactUs = {
    ProductContactUs: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                gap: 'spacing.6',
            },
            drawerHeaderWrapper: {
                w: '100%',
                alignItems: 'flex-start',
            },
            drawerTitle: {
                textTransform: 'none',
                textStyle: 'paragraphXl',
                fontWeight: 'normal',
            },
            textContainer: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.3',
            },
            mayWeHelp: {
                textStyle: 'paragraphSm',
                color: 'color.text.black',
            },
            requiredFieldsText: {
                textStyle: 'paragraphXs',
                color: 'color.text.black',
            },
            // Figma: fields stacked with 10px gap.
            inputContainer: {
                w: '100%',
                alignItems: 'flex-start',
                gap: remCalc(10),
            },
            privacyMessage: {
                textStyle: 'paragraphXs',
                textAlign: 'left',
                color: 'color.text.grey.700',
                fontWeight: 400,
                sx: {
                    'a, a:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
            recaptchaMessage: {
                textStyle: 'paragraphXs',
                textAlign: 'left',
                color: 'color.text.grey.700',
                fontWeight: 400,
                sx: {
                    'a, a:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
            // Wrapper around the two privacy lines: 15px between them, 24px before the CTA (Figma).
            privacyContainer: {
                gap: remCalc(15),
                mt: 'spacing.6',
                mb: 'spacing.6',
            },
            // Error confirmation: alert icon + red text (design-system error colour). The icon is
            // vertically centered relative to the message.
            errorContainer: {
                w: '100%',
                gap: 'spacing.1.5',
                alignItems: 'center',
            },
            errorMessage: {
                w: '100%',
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
                color: 'color.text.error',
            },
            // ─── Success confirmation (Figma 58338-20016): heading + body ──
            successContainer: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.4',
            },
            successMessage: {
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
            },
        }),
    },
}

export default productContactUs
